/**
 * 거래처 전용 화면에서 운송구간(route) 기준으로 행을 필터링합니다.
 * 저장한 문자열이 실제 route 값에 **포함(contain)** 되면 통과합니다.
 * (예: "삼남-대풍" → "삼남-대풍(냉장)", "삼남-대풍2" 모두 표시)
 */

export type RouteFilterType = 'all' | 'allow';

function normalizeRoute(value: unknown): string {
  return String(value ?? '').trim();
}

/**
 * @param type 'all' = 구간 필터 없음, 'allow' = 아래 패턴 중 하나라도 route에 포함되는 행만
 * @param patterns 허용 문자열 목록 (빈 목록이면 allow일 때 0건)
 */
export function applyRouteFilter<T extends { route?: unknown }>(
  rows: T[],
  type: RouteFilterType,
  patterns: string[]
): T[] {
  if (!rows || !Array.isArray(rows)) return [];
  if (type === 'all') return rows;

  const list = patterns.map(p => p.trim()).filter(Boolean);
  if (list.length === 0) return [];

  return rows.filter(row => {
    const r = normalizeRoute(row.route);
    if (!r) return false;
    return list.some(p => r.includes(p));
  });
}
